(function () {
    var LoginCtrl = (function () {
        function LoginCtrl() {
            this.init.apply(this, arguments);
        }

        LoginCtrl.prototype = {
            /**
             * @param $rootScope {angular.IRootScopeService}
             * @param $scope {angular.IScope}
             * @param $state {ui.IState}
             * @param localStorageService
             * @param AuthService {AuthService}
             * @param $message {$message}
             * @param $ionicScrollDelegate
             * @param $Loading {$Loading}
             * @param MKioskService {MKioskService}
             * @param $translationService {TranslationService}
             * @param $Config {$Config}
             * @param UtilityService {UtilityService}
             * @param NotificationService {NotificationService}
             * @param $mdDialog {$mdDialog}
             * @param CameraService{CameraService}
             */
            init: function ($rootScope, $scope, $state, localStorageService, AuthService, $message, $ionicScrollDelegate, $Loading, MKioskService, $translationService, $Config, UtilityService, NotificationService, $mdDialog, CameraService) {
                $scope.vm = this;
                this.$rootScope = $rootScope;
                this.$scope = $scope;
                this.$state = $state;
                this.localStorageService = localStorageService;
                this.AuthService = AuthService;
                this.$message = $message;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$Loading = $Loading;
                this.MKioskService = MKioskService;
                this.$translationService = $translationService;
                this.$Config = $Config;
                this.utilityService = UtilityService;
                this.notificationService = NotificationService;
                this.$mdDialog = $mdDialog;
                this.cameraService = CameraService;

                this.username = "";
                
                this.password = "";
                this.visiblePassword = false;

                this.currentLanguge = this.$translationService.getCurrentLanguageCode();
                this.showForm = true; // to allow AngualrJS rerender when we change language
                
                try {
                    this.utilityService.hideSplashscreen();

                    // close all dialog when go to login screen
                    this.utilityService.closeAllDialog();

                    // Unregister NotificationService when start login screen
                    if (window['cordova'] && window['FirebasePlugin']) {
                        this.notificationService.unregister();
                    }
                } catch (e) {
                    
                }
            },
            submit: function () {
                this.$Loading.show();
                var _self = this;
                this.AuthService.login(this.username, this.password)
                    .then(angular.bind(this, function () {
                        this.MKioskService.resetDriverStatsCache();

                        this.$state.go("internal.home");
                    }), this.$message.error)
                    .finally(angular.bind(this, function () {
                        this.$Loading.hide();
                    }));
            },
            onForgotPassword: function () {
                this.$state.go("internal.forgotpassword");
            }, 
            onLanguageChanged: function () {       
                this.$Loading.show();
                this.showForm = false;
                this.$translationService.loadTranslation(this.currentLanguge).then(
                    angular.bind(this, function () {
                        this.showForm = true;
                        this.$Loading.hide();         
                        
                        this.$rootScope.$emit("language-changed");
                    }),
                    angular.bind(this, function (err) {
                        this.showForm = true;
                        this.$Loading.hide();
                    }),
                )
                
                // keep for reference in case we need to change the logic to refresh directly
                // this.$translationService.setCurrentLanguageCode(this.currentLanguge);
                // setTimeout(() => {
                //     window.location.reload(true);
                // }, 100); 
            },

            toggleVisiblePassword(){
                let $input = $("#password" );
                this.visiblePassword = !this.visiblePassword;
                $input.attr("type", (this.visiblePassword ? "text" : "password"));
            }
        };
        LoginCtrl.$inject = ['$rootScope', '$scope', '$state', 'localStorageService', 'AuthService', '$message', '$ionicScrollDelegate', '$Loading', 'MKioskService', '$translationService', '$Config', 'UtilityService', 'NotificationService', '$mdDialog', 'CameraService'];
        return LoginCtrl;
    }());
    angular.module('internal.login').controller('LoginCtrl', LoginCtrl)
})();